<template>
  <div class="card">
    <div class="cardBody">
      <div class="message-container">
        <PatientInfo
          :avatar="msg.patientAvatar"
          :name="getProfileByKey({ patientProfileName: msg.patientName }, 'name')"
          :sex="getProfileByKey({ gender: Number(msg.patientGender) }, 'gender')"
          :age="getProfileByKey({ age: msg.patientAge }, 'age')"
        />
        <PreContent :cardList="getCardList()">
          <template v-slot:value="{ data }">
            <div v-if="data.slotName === 'skuInfoList'">
              <SkuList :list="data.value"></SkuList>
            </div>
          </template>
        </PreContent>
        <div style="margin-top: 14px">
          <PreTips
            :text="msg.sceneStatusText"
            :tipsStyle="getTipsStyle(msg)"
            :icon="getIcon(msg)"
          ></PreTips>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps } from 'vue'
import PatientInfo from './components/PatientInfo/index.vue'
import PreContent from './components/PreContent/index.vue'
import SkuList from './components/SkuList.vue'
import PreTips from './components/PreTips.vue'
import { getPreConfig } from './config.js'
import { getProfileByKey, isEmpty } from '@/utils/index'
import moment from 'moment'
const props = defineProps({
  msg: {
    type: Object,
    default: () => ({})
  }
})

const getCardList = () => {
  const { skuInfoList = '', createdAt = '' } = props.msg
  // 判断一个skuInfoList是否是JSON字符串
  const getList = str => {
    try {
      return JSON.parse(str)
    } catch (error) {
      return []
    }
  }

  const skuList = getList(skuInfoList)
  // 是否是单个的健康用品
  const isSingleHealthGoods = () => {
    return skuList && skuList.length == 1 && skuList[0].skuType == 4
  }

  // 处方页面配置项
  const pList = [
    {
      prop: 'skuInfoList',
      label: isSingleHealthGoods() ? '药品' : '处方药品', // 单个健康用品显示药品，其他显示处方药品
      value: skuList,
      slotName: 'skuInfoList'
    },
    {
      prop: 'createdAt',
      label: '申请时间',
      value: isEmpty(createdAt) ? '--' : moment(createdAt).format('YYYY-MM-DD HH:mm:ss')
    }
  ]
  return pList
}

const getIcon = item => {
  return getPreConfig(item).icon
}
const getTipsStyle = item => {
  return getPreConfig(item).tipsStyle
}
</script>
<style lang="scss" scoped>
.card {
  display: flex;
  justify-content: center;
  .cardBody {
    width: 432px;
    .message-container {
      background: #ffffff;
      padding: 14px 16px;
    }
  }
}
</style>
